import { FC } from "react";
import { useParams } from "react-router";
import { useSelector } from "react-redux";

import Skeleton from "../Skeleton/Skeleton";
import { CardDailyModelProps } from "./types";
import TableModel from "../TableModel/TableModel";
import { selectDailyAverageModelScoresByDateState } from "../../store/selectors/scores";
import { mapModelIcon, ModelIcons } from "../../types/models";

import styles from "./CardDailyModel.module.css";



const CardDailyModel: FC<CardDailyModelProps> = ({ model, index }) => {
  const { id, date } = useParams();
  const score = useSelector(selectDailyAverageModelScoresByDateState(Number(id), Number(model.id), date));
  const IconModel = mapModelIcon(model.name.toLowerCase() as ModelIcons);

  const renderModelName = () => {
    let name = model.name;
    if (model.data?.version) name += ` ${model.data.version}`;

    return name;
  }

  const renderScore = () => {
    if (score === null || !id) return <Skeleton height={56} width={88} />;

    if (score === undefined) {
      return <p className={styles['models-daily__value-no-data']}>No data</p>;
    }

    return score;
  }

  return (
    <div key={model.id} className={styles['models-daily']}>
      <div className={styles['models-daily__header']}>
        <h3 className={styles['models-daily__title']} id={model.id}>
          <IconModel /> {renderModelName()}
        </h3>
        <div className={styles['models-daily__info']}>
          <p className={styles['models-daily__info-label']}>Model daily SCORE</p>
          <div className={styles['models-daily__value']}>{renderScore()}</div>
        </div>
      </div>
      <TableModel model={model} index={index} />
    </div>
  )
};

export default CardDailyModel; 